import { action, makeObservable, observable } from 'mobx'

import { CreateTapeContextProps } from '@new/domains/fastBookingsTapeChart/__types'

class _TapeChartCreateTapeStore {
  createTapeContext?: CreateTapeContextProps[]
  tapeContextPeriod?: CreateTapeContextProps['period']

  itemAlreadyExists = (context: CreateTapeContextProps, list?: CreateTapeContextProps[]) =>
    list?.some(selectedTape => selectedTape.home?.id === context.home?.id)

  withoutCurrentContext = (list: CreateTapeContextProps[], context: CreateTapeContextProps) =>
    list.filter(selectedTape => selectedTape.home?.id !== context.home?.id)

  setCreateTapeContext = (tapeContext: CreateTapeContextProps[]) => {
    this.createTapeContext = tapeContext.reduce((accumulator, context) => {
      const updatedList = this.withoutCurrentContext(accumulator, context)
      return this.itemAlreadyExists(context, accumulator) ? updatedList : [...updatedList, context]
    }, this.createTapeContext || [])
  }

  setCreateTapeContextPeriod = (tapeContextPeriod?: CreateTapeContextProps['period']) => {
    this.tapeContextPeriod = tapeContextPeriod
  }

  resetCreateTapeContext = () => {
    this.createTapeContext = undefined
    this.tapeContextPeriod = undefined
  }

  constructor() {
    makeObservable(this, {
      createTapeContext: observable,
      tapeContextPeriod: observable,
      itemAlreadyExists: action.bound,
      withoutCurrentContext: action.bound,
      setCreateTapeContext: action.bound,
      setCreateTapeContextPeriod: action.bound,
      resetCreateTapeContext: action.bound,
    })
  }
}

export const TapeChartCreateTapeStore = new _TapeChartCreateTapeStore()
